
//Class gestion d'un dictionnaire avec clés unique
export class DictionaryModel {
    /**Records unique Key */
    private _records: Map<any, any> = new Map<any, any>();

    private _emptyValue: any | undefined;

    /**
     * Init
     * @param _iEmptyvalue valeur defaut vide à attribuer ou undefined ne gère pas
     */
    constructor(_iEmptyValue: any | undefined = undefined) {
        this._records = new Map<any, any>()
        this._emptyValue = _iEmptyValue;
    }

    /**
     * Ajout ou remplace selon la clés
     * @param _ikey clés UNIQUE
     * @param _iValue valeur
     */
    public Set(_ikey: any, _iValue: any) {
        this._records.set(_ikey, _iValue);
    }

    /**
    * Ajout ou remplace selon la clés avec la valeur par défaut configuré 
    * @param _iKey clés UNIQUE
    * @param _iValue valeur
    */
    public SetWithEmptyValue(_iKey: any) {
        this._records.set(_iKey, this._emptyValue);
    }

    /**
     * Retourne la valeur selon la clés
     * @param _ikey clés UNIQUE
     * @returns 
     */
    public GetByKey(_iKey: any): any | null {

        return this._records.get(_iKey) ?? null
    }

    /**
    * Retourne si la valeur est égal à la valeur vide configurée à l'initialisation
    * @param _ikey clés UNIQUE
    * @returns 
    */
    public IsEmptyValue(_iKey: any): any | null {

        return this.GetByKey(_iKey) == null || this.GetByKey(_iKey) == this._emptyValue
    }

    /**
     * Return si la clés est présente
     * @param _iKey clés UNIQUE
     * @returns boolean
     */
    public Exist(_iKey: any): boolean {
        return this._records.has(_iKey);
    }

    /**
     * Retire la clés
     * @param _iKey clés UNIQUE
     * @return boolean isdeleted false no exist
     */
    public Remove(_iKey: any): boolean {
        return this._records.delete(_iKey);
    }

    /**
     * remove all the records with this value
     * @param _iRemoveValue value to remove the records
     * @returns void
     */
    public RemoveByValue(_iRemoveValue: any) {
        return this._records.forEach((val, key) => {
            if (val == _iRemoveValue) {
                this.Remove(key)
            }
        });
    }

    /**
     * Remplace une valeur
     * @param _iSearchValue 
     * @param _iNewValue 
     * @returns 
     */
    public ReplaceValues(_iSearchValue: any, _iNewValue: any) {
        return this._records.forEach((val, key) => {
            if (val == _iSearchValue) {
                this.Set(key, _iNewValue)
            }
        });
    }

    /**
    * Remplace les valeurs configurée vide par cette valeur
    * @param _iNewValue 
    * @returns 
    */
    public ReplaceEmptyValues(_iNewValue: any) {
        return this._records.forEach((val, key) => {
            if (val == this._emptyValue) {
                this.Set(key, _iNewValue)
            }
        });
    }

    /**
     * Indique si il existe des clés avec la valeur vide configurée
     * @returns 
     */
    public ExitEmptyValue() {
        return this.CountEmptyValue() > 0;
    }

    /**
    * Indique si il existe des clés avec la valeur non vide configurée
    * @returns 
    */
    public ExitNotEmptyValue() {
        return this.CountEmptyValue() != this.Count();
    }

    /**
    * Indique si il existe des clés avec avec la valeur vide configurée
    * @returns 
    */
    public CountEmptyValue(): number {
        return this.GetKeysWithValue(this._emptyValue).length;
    }

    /**
     * Retourne la liste des clés disposant de cette valeur
     * @param _iSearchValue 
     * @returns any[]
     */
    public GetKeysWithValue(_iSearchValue: any): any[] {
        let oKeys: any[] = [];
        if (this.Exists())
            this._records.forEach((value, key) => {
                if (value === _iSearchValue) {
                    oKeys.push(key)
                }
            });
        return oKeys;
    }


    /**
* Remove all Records
*/
    public Clear() {
        this._records.clear();
    }
    /**
     * retourne si il dispose d'enregistrement
     * @returns 
     */
    public Exists(): boolean {
        return this._records.size > 0;
    }

    /**
     * Return le nombre de données
     * @returns nombre
     */
    public Count(): number {
        return this._records.size;
    }

    /**
     * retourne l'ensemble des valeurs présentes
     * @returns 
     */
    public GetAllValues(): any[] {
        return Array.from(this._records.values())
    }

    /**
     * Retourne l'ensemble des clés
     * @returns 
     */
    public GetAllKeys(): any[] {
        return Array.from(this._records.keys())
    }

}